// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__xuMjG","item":"Footer_item__JZLtS","selectedItem":"Footer_selectedItem__uhk7r"};